import React, { useContext, useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';
import { Input, Spinner, Text, useConst } from '@chakra-ui/react';
import { Home_context } from '../../context/home_context';

export default function SearchBar() {
  const { HendleApi_call_get_suggesions, Suggestion_data_state } =
    useContext(Home_context);
  const [value, setValue] = useState('');
  function HendleCall(e) {
    if (e?.key == 'Enter') {
      console.log(e?.target?.value);
      if (e?.target?.value?.length > 0)
        HendleApi_call_get_suggesions(e?.target?.value);
    }
  }



  
  return (
    <div className="pt-0 mt-0 sticky translate-y-[-10.2px] top-[76.7px] z-[100px] bg-white transition-all   ">
      {/* <div
      id="sticky-div"
      className={`sticky top-[52px] z-[100px] bg-white transition-all ${
        isSticky ? 'border-[1px] border-red-600' : ''
      }`}
    > */}
      <Text className="font-semibold text-[25px] pb-[8px] ">
        <span>Search for</span>
        <span className="theam_color_darker"> Raw Materials</span>
      </Text>
      <div className=" home_search_bar card flex justify-content-center   ">
        <div className="relative w-[100%] h-[60px]">
          {/* <textarea
            rows="1"
            cols="50"
            placeholder="Search for raw materials"
            id="username"
            className=" overflow-hidden ggg text-[13px]  outline-none resize-none  w-[100%] h-[70px]  border-[1px] border-[#d6d6d6] p-[16px] rounded-md box_shadow_one"
            onKeyDown={(e) => HendleCall(e)}
          /> */}
          <input
            onKeyDown={(e) => HendleCall(e)}
            className=" overflow-hidden text-[13px]  outline-none resize-none  w-[100%] h-[100%]  border-[1px] border-[#d6d6d6] p-[16px] rounded-md box_shadow_one"
          />
          {Suggestion_data_state?.Suggestion_data_state_loading && (
            <Spinner className="absolute top-[30%] right-[2%]  translate-x-[50%] text-gray-400 " />
          )}
        </div>
      </div>
    </div>
  );
}
